import swapVideoSource from "./swap-video-source";
import debounce from "lodash/debounce";

const playVideos = () => {
    const videos = document.querySelectorAll(".sequential-video .video-link-block__video");
    if (videos.length == 0) return;

    videos.forEach((video) => {
        video.removeAttribute("autoplay");
        video.removeAttribute("loop");
    });
    videos[0].play();

    videos.forEach((video, index) => {
        video.addEventListener("ended", () => {
            if (index < videos.length - 1) {
                videos[index + 1].play();
            }
            else {
                videos[0].play();
            }
        })
    })
};

const initiateIFrame = () => {
    document.querySelectorAll(".playIcon").forEach((video) => {
        video.addEventListener("click", (e) => {
            const videoWrapper = e.currentTarget.closest(".video-wrap");
            const videoId = e.currentTarget.dataset.src;
            const iFrameTag = `<iframe class="embed-responsive-item" id="frmYoutube" src="https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1" allowFullScreen="allowfullscreen" allow="autoplay" width="850" height="480"></iframe>`;

            $(videoWrapper).find(".video-thumbnail").after(iFrameTag);

            videoWrapper.classList.add("playing");
        })
    })
}

const isCorrectSource = (sourceUrl, mobileUrlCheck, mobileBreakPoint) => {
    if (!sourceUrl) return;

    // If mobile and source is mobile version
    if (window.innerWidth < mobileBreakPoint && sourceUrl.substring(sourceUrl.length - mobileUrlCheck.length) == mobileUrlCheck) return true;

    // If desktop and source is desktop version
    if (window.innerWidth >= mobileBreakPoint && sourceUrl.substring(sourceUrl.length - mobileUrlCheck.length) != mobileUrlCheck) return true;
}

const swapVideo = async () => {
    if ($(".video-showcase-block video").length == 0) return;

    const video = $(".video-showcase-block video");

    const origSrc = await swapVideoSource(video, window.innerWidth < 992);

    window.addEventListener("resize", debounce(async () => {
        let videoSourceUrl = video.attr("src");
        if (isCorrectSource(videoSourceUrl, "-mobile.mp4", 992)) return;

        await swapVideoSource(video, window.innerWidth < 992);

    }, 300))
}

document.addEventListener("DOMContentLoaded", () => {
    playVideos();
    initiateIFrame();
    swapVideo();
})